function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import { withMapContext } from './Map';
var MapPadding = /*#__PURE__*/function (_React$Component) {
  function MapPadding() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(MapPadding, _React$Component);
  var _proto = MapPadding.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      mapContext = _this$props.mapContext,
      padding = _this$props.padding;
    this.previousPadding = mapContext.padding;
    mapContext.padding = padding;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var mapContext = this.props.mapContext;
    mapContext.padding = this.previousPadding;
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("span", {
      className: "map-padding--placeholder",
      "data-padding": this.props.padding
    });
  };
  return MapPadding;
}(React.Component);
MapPadding.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Set the padding ([top, right, bottom, left]).
   */
  padding: PropTypes.arrayOf(PropTypes.number),
  /**
   * @ignore
   */
  mapContext: PropTypes.object.isRequired
} : {};
export default withMapContext(MapPadding);